import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FaCheck } from 'react-icons/fa'
import moment from 'moment'
import { translations } from '../../utils/constants'
import { setLanguage } from '../../Redux/actions/languageAction'
import { italyFlag, englishFlag } from '../../assets'
import { ROLE_LABELS } from './Settings'

const LANGUAGES = [
  { value: 'en', flag: englishFlag, labelKey: 'english', sample: 'dddd, DD MMMM YYYY' },
  { value: 'it', flag: italyFlag, labelKey: 'italian', sample: 'dddd, DD MMMM YYYY' },
]

// Interface preferences. Language lives in the persisted redux store, so a
// choice here survives reloads and is the same switch as the header flag.
const Preferences = ({ language }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state?.authReducer?.user)
  const t = translations[language] || {}

  return (
    <div className='ps-section'>
      <div className='ps-section-head'>
        <h3>{t.languagePreference}</h3>
        <p>{t.languageHint}</p>
      </div>

      <div className='ps-lang-grid'>
        {LANGUAGES.map((lang) => {
          const active = language === lang.value
          return (
            <button
              type='button'
              key={lang.value}
              className={`ps-lang-card${active ? ' active' : ''}`}
              onClick={() => dispatch(setLanguage(lang.value))}
            >
              <img className='ps-lang-flag' src={lang.flag} alt={t[lang.labelKey]} />
              <span className='ps-lang-text'>
                <span className='ps-lang-name'>{t[lang.labelKey]}</span>
                <span className='ps-lang-sample'>
                  {moment().locale(lang.value).format(lang.sample)}
                </span>
              </span>
              {active && <span className='ps-lang-check'><FaCheck /></span>}
            </button>
          )
        })}
      </div>

      <div className='ps-section-head ps-section-gap'>
        <h3>{t.accountLabel}</h3>
      </div>
      <div className='ps-kv'>
        <div className='ps-kv-row'>
          <span>{t.roleLabel}</span>
          <strong>{ROLE_LABELS[user?.role] || user?.role || '-'}</strong>
        </div>
        <div className='ps-kv-row'>
          <span>{t.organizationLabel}</span>
          <strong className='capitalized-name'>{user?.organization || '-'}</strong>
        </div>
        <div className='ps-kv-row'>
          <span>{t.userIdLabel}</span>
          <code className='ps-code'>{user?.id || '-'}</code>
        </div>
      </div>
    </div>
  )
}

export default Preferences
